class Coordinates {

	public longitude?: number = undefined;

	public latitude?: number = undefined;

	constructor(longitude?: number, latitude?: number) {
		this.longitude = longitude;
		this.latitude = latitude;
	}

	public static inEurasia(latitude: number, longitude: number) {
		// Массив из 36 зон
		// Формат каждой зоны: [minLon, maxLon, minLat, maxLat]
		// Можно дать этот список иишке и попросить сформировать данные для https://geojson.io/ (чтобы посмотреть эти зоны)
		const slices = [
			[-10.0,  -5.0,  36.0, 44.0], // Слайс 1: Португалия / Зап. Испания
			[ -5.0,   0.0,  36.0, 51.0], // Слайс 2: Восток Испании / Центр Франции
			[  0.0,   3.0,  38.6, 51.8], // Слайс 3: Восток Франции / Бельгия
			[  3.0,   7.5,  41.5, 71.5], // Слайс 4: Марсель / Швейцария / Норвегия
			[  7.5,  10.0,  43.5, 71.5], // Слайс 5: Север Италии / Германия / Норвегия
			[ 10.0,  15.0,  36.5, 71.5], // Слайс 6: Италия (Рагуза) / Австрия / Швеция
			[ 15.0,  20.0,  36.4, 71.5], // Слайс 7: Балканы / Польша / Швеция
			[ 20.0,  25.0,  36.4, 71.5], // Слайс 8: Греция / Румыния / Финляндия
			[ 25.0,  30.0,  36.0, 71.5], // Слайс 9: Турция / Беларусь / РФ
			[ 30.0,  34.0,  36.0, 72.5], // Слайс 10: Турция / Кольский п-ов
			[ 34.0,  40.0,  16.0, 70.0], // Слайс 11: Левант / Мекка / Центр РФ
			[ 40.0,  45.0,  12.5, 69.0], // Слайс 12: Йемен / Кавказ / п-ов Канин
			[ 45.0,  50.0,  12.5, 68.5], // Слайс 13: Йемен / Иран / Волга
			[ 50.0,  55.0,  14.5, 69.0], // Слайс 14: Оман / Иран / Урал
			[ 55.0,  60.0,  16.5, 73.5], // Слайс 15: Оман / Казахстан / Ямал
			[ 60.0,  65.0,  25.0, 73.5], // Слайс 16: Пакистан / Обь
			[ 65.0,  70.0,  20.0, 73.5], // Слайс 17: Индия (Гуджарат) / Сибирь
			[ 70.0,  75.0,  12.0, 73.5], // Слайс 18: Индия (Мангалуру) / Сибирь
			[ 75.0,  80.0,   8.0, 75.0], // Слайс 19: Юг Индии / Сибирь
			[ 80.0,  85.0,   9.5, 75.0], // Слайс 20: Восток Индии / Сибирь
			[ 85.0,  90.0,  19.5, 77.0], // Слайс 21: Бенгалия / Сибирь
			[ 90.0,  95.0,  15.0, 77.0], // Слайс 22: Мьянма / Сибирь
			[ 95.0, 100.0,   5.5, 77.8], // Слайс 23: Таиланд / Таймыр
			[100.0, 105.0,   1.2, 77.8], // Слайс 24: Малайзия / Таймыр
			[105.0, 110.0,   8.5, 77.8], // Слайс 25: Вьетнам / Таймыр
			[110.0, 115.0,  17.0, 78.0], // Слайс 26: Юг Китая / Мыс Челюскин
			[115.0, 120.0,  22.0, 76.0], // Слайс 27: Восток Китая / Якутия
			[120.0, 125.0,  24.5, 74.0], // Слайс 28: Шанхай / Якутия
			[125.0, 130.0,  34.0, 74.0], // Слайс 29: Южная Корея / Амур
			[130.0, 135.0,  41.0, 73.5], // Слайс 30: Владивосток / Хабаровск
			[135.0, 140.0,  43.0, 73.5], // Слайс 31: Хабаровский край
			[140.0, 150.0,  43.0, 73.0], // Слайс 32: Охотское море (материк)
			[150.0, 160.0,  50.0, 71.5], // Слайс 33: Юг Камчатки / Магадан
			[160.0, 170.0,  51.5, 71.0], // Слайс 34: Север Камчатки / Чукотка
			[170.0, 180.0,  58.0, 71.0], // Слайс 35: Чукотка (восточное полушарие)
			[-180.0,-169.0, 60.0, 70.0]  // Слайс 36: Чукотка (западное полушарие)
		];

		for (const slice of slices) {
			if (longitude >= slice[0] && // >= minLon
				  longitude <= slice[1] && // <= maxLon
				  latitude >= slice[2] && // >= minLat
				  latitude <= slice[3] // <= maxLat
			) {
				return true;
			}
		}

		return false;
	}

}

export default Coordinates;
